<template>
  <!-- Workspace -->
  <div
    ref="profileSpace"
    class="flex justify-between items-center mb-2 py-2"
    aria-hidden
    @click.stop="showWorkspaceSelection = !showWorkspaceSelection"
  >
    <div class="flex gap-2.5 cursor-pointer w-[80%]">
      <div class="flex relative flex-col">
        <Avatar size="sm">{{ teamName[0]?.toUpperCase() }}</Avatar>
        <TransitionPopup>
          <div
            v-show="showWorkspaceSelection"
            class="bg-app-white dark:bg-app-dark-surface1 border border-app-gray-200 absolute top-11 -left-2 w-[224px] shadow-lg rounded-lg z-40"
          >
            <h6 v-if="teams.length > 0" class="px-4 py-3 mt-3 text-xs font-semibold text-app-gray-500">YOUR ORGANIZATIONS</h6>
            <ul :class="['p-0 m-0 overflow-y-auto', teams.length > 3 ? 'h-[182px]' : 'h-auto']">
              <li
                v-for="team in teams"
                :key="team.name"
                class="flex items-center gap-4 cursor-pointer hover:bg-app-gray-700 px-4 py-3"
                :class="team.id === selectedTeam.id ? 'bg-app-gray-700' : ''"
                aria-hidden
                :title="team.display_name"
                @click.stop="selectTeamWorkspace(team)"
              >
                <Avatar size="xs" class="capitalize">{{ team.name[0] }}</Avatar>
                <span class="text-sm font-semibold text-app-gray-900 capitalize truncate w-[80%]">{{ team.display_name }}</span>
              </li>
            </ul>
          </div>
        </TransitionPopup>
      </div>
      <div class="w-[80%]">
        <h6 class="text-base font-semibold text-app-gray-900 truncate capitalize" :title="workspaceName">{{ workspaceName }}</h6>
        <p class="text-xs font-normal text-app-gray-500 capitalize">{{ subsriptionPlan }}</p>
      </div>
    </div>
    <Icon name="selector-icon" class="cursor-pointer" />
  </div>
</template>

<script lang="ts">
import { Avatar } from "@toruslabs/vue-components/Avatar";
import { Icon } from "@toruslabs/vue-components/Icon";
import { defineComponent } from "vue";

import TransitionPopup from "@/components/TransitionPopup";
import { billingModule, teamModule } from "@/store";
import { ROUTES } from "@/utils/enums";

export default defineComponent({
  name: "WorkspaceSelector",
  components: { Avatar, Icon, TransitionPopup },
  props: {
    isMobileDrawer: {
      type: Boolean,
      default: false,
    },
    teamName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showWorkspaceSelection: false,
    };
  },
  computed: {
    teams() {
      return teamModule.teamsGetter;
    },
    selectedTeam() {
      return teamModule.selectedTeamGetter(this.teamName);
    },
    workspaceName() {
      return this.selectedTeam.display_name;
    },
    subsriptionPlan() {
      const { customer } = billingModule.getSubscription(this.selectedTeam.id);
      if (customer) {
        const { plan } = customer;
        return `${plan} Plan`;
      }
      return "Plan";
    },
  },
  watch: {
    showWorkspaceSelection(flag) {
      if (flag) {
        document.addEventListener("click", this.handleClickOutside);
      } else {
        document.removeEventListener("click", this.handleClickOutside);
      }
    },
  },
  methods: {
    selectTeamWorkspace(team: { name: string }) {
      if (this.teamName !== team.name) {
        this.$router.push({ name: ROUTES.HOME, params: { teamName: team.name } });
        this.showWorkspaceSelection = false;
      }
    },
    handleClickOutside(event: Event) {
      if (this.$refs.profileSpace && !(this.$refs.profileSpace as HTMLElement).contains(event.target as HTMLInputElement)) {
        this.showWorkspaceSelection = false;
      }
    },
  },
});
</script>
